import React, { useState, useRef, useEffect } from "react";
import { Redirect } from 'react-router-dom';

import { t } from "i18next";

import { useDispatch, useSelector } from "react-redux";
import { Container, Card, Col, Row, Form, Image} from 'react-bootstrap'
import BackgroundSlider from 'react-background-slider'

import {AiOutlineEye, AiOutlineEyeInvisible} from 'react-icons/ai'

import { login, loginAAD, loginTwoFactor, logout, resendTwoFactor } from "../../actions/auth-action";

import AuthService from "../../services/auth.service";

import { showMessage, encryptBase64, removeAuth, getExpAuth, isNullUndefinedOrEmpty, onGoToSG3PlusClick, encodeTokenForTransport } from "../../common/Helpers"
import {__MessageTypes, __WhiteEmailDomainList} from "../../common/Dictionaries"

import img1 from '../../images/bridg/login-bg-1.jpg'
import img2 from '../../images/bridg/login-bg-2.jpg'
import img3 from '../../images/bridg/login-bg-3.jpg'
import LanguajeFlags from "../../components/TopNavBar/LanguajeFlags";

import { TagPicker } from '@fluentui/react/lib/Pickers';

import sg3 from "../../images/sg3plus.png"
import { RECAPTCHA_SITE_KEY, WEB_AUTH_URL, WEB_CORE_URL } from "../../configurations/paths.config";
import { PARAM_NAME_PW } from "../../configurations/staticTypes.config";
import { DefaultButton, PrimaryButton } from "@fluentui/react";
import { loginRequest } from "../../configurations/entraId.azure.config";
import { useMsal } from "@azure/msal-react";

import './style.css'
import MessageBox from "../../components/Controls/Message/MessageBox";
import SetAuth from "./SetAuth";

import ReCAPTCHA from 'react-google-recaptcha';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";


const TWO_FACTOR_EXPIRATION_SECONDS = 150;

const Login = (props) => {
	const { instance } = useMsal();
	const dispatch = useDispatch();
	const history = useHistory();

	const { user: currentAuth } = useSelector((state) => state.auth);

	const form = useRef();
	const captchaRef = useRef(null)
	const captchaLoginRef = useRef(null)
	const captchaAADRef = useRef(null)
	
	const [loginAADCalled, setLoginAADCalled] = useState(null);
	const [domainList, setDomainList] = useState(null);
	const [integrationError, setiIntegrationError] = useState(false);

	const [loginModel, setLoginModel] = useState({
		email: "",
  
		domain: "",
		password: "",
  
		rememberme: false,
  
		emailValidated: false,
		formTwoFactorEnabled: false,
		clientUserListAccess: null,
  
		twoFactorCode: "",
	});
	
	useEffect(() => {
		if (loginAADCalled === false || loginAADCalled === null) {
			instance.handleRedirectPromise().then((response) => {
				if (response) {
					if (!isNullUndefinedOrEmpty(response) && !isNullUndefinedOrEmpty(response.accessToken)) {
						setLoginAADCalled(true);
						manageGetClientsAccountsFromEmail(response.account.username, "AAD", response.accessToken, response.accessToken);
						setLoginMode("AAD")
						setLoginMsalToken(response.accessToken)
					}
				}
				else {
					setLoginAADCalled(true);
				}
			}).catch(error => {
				setLoginAADCalled(true);
				setLoadingAAD(false);
				showMessage(setMessageConfig, true, __MessageTypes.ERROR, t((error && error.message) || 'data-lang-msg-internalerror'));
			});
		}
	}, [instance, loginAADCalled])

	useEffect(() => {
		const _error = window.sessionStorage.getItem("legacyintegrationerror")
		if (!isNullUndefinedOrEmpty(_error) && integrationError === false) {
			window.sessionStorage.removeItem("legacyintegrationerror")
			setiIntegrationError(true)
		}
	}, [integrationError, setiIntegrationError])


	const [isInValidLoginModel, setIsInValidLoginModel] = useState(
	  {
		email: false,
		domain: false,
		password: false,
		emailMessageError: "",
		passwordMessageError: "",
		username: false,

		twoFactorCode: false,
		twoFactorCodeMessageError: "",
	  }
	);
	
	const [showPassword, setShowPassword] = useState(false);

	const [loadingEmail, setLoadingEmail] = useState(false);
	const [loadingLogin, setLoadingLogin] = useState(false);
	const [loadingTwoFactor, setLoadingTwoFactor] = useState(false);
	const [loadingResend, setLoadingResend] = useState(false);
	const [loadingAAD, setLoadingAAD] = useState(false);
	const [twoFactorRemainingSeconds, setTwoFactorRemainingSeconds] = useState(0);
	
	const [loginMode, setLoginMode] = useState(null);
	const [loginMsalToken, setLoginMsalToken] = useState(null);
	
	const { isLoggedIn } = useSelector(state => state.auth);

	const [messageConfig, setMessageConfig] = useState({
	  message : null,
	  messageType : "",
	  showMessage : false,
	});
	const isLoading = loadingEmail || loadingLogin || loadingTwoFactor || loadingResend || loadingAAD;
	const isTwoFactorFormEnabled = loginModel.emailValidated && loginModel.formTwoFactorEnabled;
	const isTwoFactorCodeExpired = isTwoFactorFormEnabled && twoFactorRemainingSeconds <= 0;

	const clearMessage = () => {
		setMessageConfig({
			message: null,
			messageType: "",
			showMessage: false,
		});
	};

	const startTwoFactorTimer = () => {
		setTwoFactorRemainingSeconds(TWO_FACTOR_EXPIRATION_SECONDS);
	};

	const stopTwoFactorTimer = () => {
		setTwoFactorRemainingSeconds(0);
	};

	const formatRemainingTime = (totalSeconds) => {
		const safeSeconds = Math.max(totalSeconds, 0);
		const minutes = Math.floor(safeSeconds / 60).toString().padStart(2, '0');
		const seconds = (safeSeconds % 60).toString().padStart(2, '0');

		return `${minutes}:${seconds}`;
	};

	const getTwoFactorExpiredMessage = () => {
		const key = 'data-lang-msg-twofactorcodeexpired';
		const translated = t(key);

		return translated === key ? 'El código venció. Reenvía un nuevo código.' : translated;
	};

	const getTwoFactorExpiresInLabel = () => {
		const key = 'data-lang-lbl-twofactorcodeexpiresin';
		const translated = t(key);

		return translated === key ? 'El código vence en' : translated;
	};

	useEffect(() => {
		if (!loginModel.formTwoFactorEnabled || twoFactorRemainingSeconds <= 0 || loadingTwoFactor) {
			return undefined;
		}

		const timeoutId = window.setTimeout(() => {
			setTwoFactorRemainingSeconds(prevState => Math.max(prevState - 1, 0));
		}, 1000);

		return () => window.clearTimeout(timeoutId);
	}, [loginModel.formTwoFactorEnabled, twoFactorRemainingSeconds, loadingTwoFactor]);

	const getSelectedAccount = () => {
		return loginModel.clientUserListAccess ? loginModel.clientUserListAccess.find(x => x.selected === true) : null;
	};

	const getSelectedUserContext = () => {
		const selectedAccount = getSelectedAccount();
		if (isNullUndefinedOrEmpty(selectedAccount)) {
			return null;
		}

		const userNameParts = selectedAccount.userName.split('\\');
		const isSuperAdminAccount = selectedAccount.userName.startsWith('sAdmin\\');

		return {
			selectedAccount,
			isSuperAdminAccount,
			userName: userNameParts.length > 1 ? userNameParts[1] : selectedAccount.userName,
			domain: isSuperAdminAccount ? loginModel.domain : userNameParts[0],
		};
	};

	const resetEmailCaptcha = () => {
		if (captchaRef.current && captchaRef.current.reset) {
			captchaRef.current.reset();
		}
	};

	const resetLoginCaptcha = () => {
		if (captchaLoginRef.current && captchaLoginRef.current.reset) {
			captchaLoginRef.current.reset();
		}
	};

	const resetAADCaptcha = () => {
		if (captchaAADRef.current && captchaAADRef.current.reset) {
			captchaAADRef.current.reset();
		}
	};

	const redirectAfterSuccessfulLogin = () => {
		let urlRedirect = new URLSearchParams(props.location.search).get('RedirectUrl');

		if (isNullUndefinedOrEmpty(urlRedirect)) {
			onGoToSG3PlusClick();
			return;
		}

		switch (urlRedirect) {
			case "cbf": {
				const stringToBase64 = encryptBase64(getExpAuth(), PARAM_NAME_PW);
				urlRedirect = WEB_CORE_URL + "/login?stats=success&tk=" + encodeURIComponent(stringToBase64);
				window.location.replace(`${urlRedirect}`);
				return;
			}
			default:
				window.location.reload();
				return;
		}
	};

	useEffect(() => {
		const querySG3Url = new URLSearchParams(props.location.search).get('RedirectUrl');
		const queryLogout = new URLSearchParams(props.location.search).get('lgo');

		if (isLoggedIn && queryLogout === "true" && currentAuth) {
			const redirectUrl = WEB_AUTH_URL + (!isNullUndefinedOrEmpty(querySG3Url) ? "/login?RedirectUrl=cbf" : "");

			dispatch(logout(redirectUrl, false, currentAuth.userName)).catch(() => {
				setLoadingLogin(false);
			});
		}
	}, [isLoggedIn, currentAuth, props.location.search, dispatch]);

	if (isLoggedIn) {
		let querySG3Url = new URLSearchParams(props.location.search).get('RedirectUrl')
		const queryLogout = new URLSearchParams(props.location.search).get('lgo')
		const queryTk = new URLSearchParams(window.location.search).get('tk')
  
		if (queryLogout !== null && queryLogout !== undefined && queryLogout !== "") {
		  if (queryLogout === "true") {
			return null;
		  } else {
			return <Redirect to="/profile" />;
		  }
		}
		else if (querySG3Url !== null && querySG3Url !== undefined && querySG3Url !== "") {
			if (querySG3Url === "cbf") {
			  switch (querySG3Url) {
				case "cbf":
				  let stringToBase64 = encryptBase64(getExpAuth(), PARAM_NAME_PW);
	
				  querySG3Url = WEB_CORE_URL + "/login?stats=success&tk=" + encodeURIComponent(stringToBase64);
				  break;
				  default:
					break;
			  }
			  window.location.replace(`${querySG3Url}`);
			}
			else {
			  return <Redirect to="/profile" />;
			}
		}
		else {
			return <Redirect to="/profile" />;
		}
	}

	const onChangePassword = (e) => {
		clearMessage();

		const password = e.target.value;
		setIsInValidLoginModel(prevState => ({
			...prevState,
			password: (password === "")
		}));

		setLoginModel(prevState => ({
			...prevState,
			password: password
		}));
	};
	
	const onChangeTwoFactor = (e) => {
		clearMessage();

		const twoFactorCode = String(e.target.value).normalize('NFKC').replace(/[^\d]/g, '').slice(0, 6);
		setIsInValidLoginModel(prevState => ({
		  ...prevState,
		  twoFactorCode: (twoFactorCode === "")
		}));
  
		setLoginModel(prevState => ({
		  ...prevState,
		  twoFactorCode: twoFactorCode
		}));
	};

	const onChangeRememberMe = (e) => {
		clearMessage();

	  const rememberme = e.target.checked;

		setLoginModel(prevState => ({
			...prevState,
			rememberme: rememberme
		}));
	};

	const isValidFormControl = (value) => {
		return value === "" ? true : false;
	};

	const isInValidEmail = (email) => {
	  var emailShemaInvalid = false;

	  const hasEspecialEmail = __WhiteEmailDomainList.some(elemento => email.includes(elemento));
	  if (email !== "") {
		if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(email) === false && !hasEspecialEmail) {
		//if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(email) === false) {
		  emailShemaInvalid = true;
		  setIsInValidLoginModel(prevState => ({
			...prevState,
			email: true,
			emailMessageError: t('data-lang-msg-invalid-email')
		  }));
		}
	  }
	  else {
		setIsInValidLoginModel(prevState => ({
		  ...prevState,
		  email: true,
		  emailMessageError: t('data-lang-msg-required-email')
		}));
	  }

	  return emailShemaInvalid;
	};
	
	const filterSuggestedDomains = (filterText, _domainList) => {
		const _text = filterText
		  ? (domainList || []).filter(
			  domain => domain.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 && !listContainsDomainList(domain, _domainList),
			)
		  : [];
		return _text;
	};

	const listContainsDomainList = (domain, domainList) => {
		if (!domainList || !domainList.length || domainList.length === 0) {
			return false;
		}
		return domainList.some(compareDomain => compareDomain.key === domain.key);
	};

	const getTextFromItem = (item) => {
		return item.name;
	};

	const handleChangeAutocomplete = (e) => {
		clearMessage();

		if (e && e.length !== 0) {
		  setIsInValidLoginModel(prevState => ({
			...prevState,
			domain: false
		  }));
		  setLoginModel(prevState => ({
			...prevState,
			domain: e[0].key
		  }));
		}
		else {
		  setIsInValidLoginModel(prevState => ({
			...prevState,
			domain: true
		  }));
		  setLoginModel(prevState => ({
			...prevState,
			domain: ""
		  }));
		}
	};

	const handleLogin = async (e) => {
		if (e !== undefined) {
			e.preventDefault();
		}

		if (loadingLogin) {
			return;
		}

		clearMessage();

		const selectedUserContext = getSelectedUserContext();
		const _isInvalidUserName = isNullUndefinedOrEmpty(selectedUserContext);
		const _isInvalidPassword = loginMode === "AAD" ? false : isValidFormControl(loginModel.password);
		const _isInvalidDomain = selectedUserContext && selectedUserContext.isSuperAdminAccount === true && isNullUndefinedOrEmpty(loginModel.domain);

		setIsInValidLoginModel(prevState => ({
			...prevState,
			password: _isInvalidPassword,
			username: _isInvalidUserName,
			domain: _isInvalidDomain
		}));

		if (_isInvalidPassword || _isInvalidUserName || _isInvalidDomain) {
			return;
		}

		const captcha_token = loginMode === "FBA"
			? (captchaLoginRef.current && captchaLoginRef.current.getValue ? captchaLoginRef.current.getValue() : null)
			: loginMode === "AAD"
				? (captchaAADRef.current && captchaAADRef.current.getValue ? captchaAADRef.current.getValue() : null)
				: null;

		if ((loginMode === "FBA" || loginMode === "AAD") && isNullUndefinedOrEmpty(captcha_token)) {
			showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-select-recaptcha'));
			return;
		}

		setLoadingLogin(true);

		try {
			const recaptcha_login_token = !isNullUndefinedOrEmpty(captcha_token) ? captcha_token : null;
			const functionLogin = loginMode !== "AAD" ? login : loginAAD;
			const data = await dispatch(functionLogin(
				selectedUserContext.userName,
				loginModel.password,
				selectedUserContext.domain,
				loginModel.rememberme,
				loginMode,
				localStorage.getItem("i18nextLng"),
				recaptcha_login_token,
				loginMsalToken
			));

			if (data.data === "2FR") {
				setLoginModel(prevState => ({
					...prevState,
					formTwoFactorEnabled: true,
					twoFactorCode: "",
				}));

				setIsInValidLoginModel(prevState => ({
					...prevState,
					twoFactorCode: false,
					twoFactorCodeMessageError: "",
				}));

				startTwoFactorTimer();
				showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-twofactorcodesent'));
				return;
			}

			if (data.data === "") {
				if (loginMode === "AAD") {
					resetAADCaptcha();
				}
				else {
					resetLoginCaptcha();
				}

				showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(data.message));
				return;
			}

			redirectAfterSuccessfulLogin();
		} catch (error) {
			if (loginMode === "AAD") {
				resetAADCaptcha();
			}
			else {
				resetLoginCaptcha();
			}

			showMessage(setMessageConfig, true, __MessageTypes.ERROR, t((error && error.response && error.response.data && error.response.data.message) || 'data-lang-msg-internalerror'));
		} finally {
			setLoadingLogin(false);
		}
	};

	const handleResendTwoFactorCode = async (e) => {
		if (e !== undefined) {
			e.preventDefault();
		}

		if (loadingResend) {
			return;
		}

		clearMessage();

		const selectedUserContext = getSelectedUserContext();
		const _isInvalidUserName = isNullUndefinedOrEmpty(selectedUserContext);
		const _isInvalidPassword = loginMode === "AAD" ? false : isValidFormControl(loginModel.password);

		setIsInValidLoginModel(prevState => ({
			...prevState,
			password: _isInvalidPassword,
			username: _isInvalidUserName
		}));

		if (_isInvalidPassword || _isInvalidUserName) {
			return;
		}

		setLoadingResend(true);

		try {
			await dispatch(resendTwoFactor(
				selectedUserContext.userName,
				loginModel.password,
				selectedUserContext.domain,
				loginModel.rememberme,
				loginMode,
				localStorage.getItem("i18nextLng"),
				2
			));

			setLoginModel(prevState => ({
				...prevState,
				twoFactorCode: "",
			}));

			setIsInValidLoginModel(prevState => ({
				...prevState,
				twoFactorCode: false,
				twoFactorCodeMessageError: "",
			}));

			startTwoFactorTimer();
			showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-resentcode'));
		} catch (error) {
			showMessage(setMessageConfig, true, __MessageTypes.ERROR, t((error && error.response && error.response.data && error.response.data.message) || 'data-lang-msg-internalerror'));
		} finally {
			setLoadingResend(false);
		}
	};

	const handleTwoFactorLogin = async (e) => {
		if (e !== undefined) {
			e.preventDefault();
		}

		if (loadingTwoFactor) {
			return;
		}

		clearMessage();

		if (isTwoFactorCodeExpired) {
			setIsInValidLoginModel(prevState => ({
				...prevState,
				twoFactorCode: true,
				twoFactorCodeMessageError: getTwoFactorExpiredMessage()
			}));

			return;
		}

		const selectedUserContext = getSelectedUserContext();
		const _isInvalidUserName = isNullUndefinedOrEmpty(selectedUserContext);
		const _isInvalidPassword = loginMode === "AAD" ? false : isValidFormControl(loginModel.password);
		const _isInvalidTwoFactorCode = isValidFormControl(loginModel.twoFactorCode);

		setIsInValidLoginModel(prevState => ({
			...prevState,
			password: _isInvalidPassword,
			username: _isInvalidUserName,
			twoFactorCode: _isInvalidTwoFactorCode,
			twoFactorCodeMessageError: _isInvalidTwoFactorCode ? t('data-lang-msg-required') : ""
		}));

		if (_isInvalidPassword || _isInvalidUserName || _isInvalidTwoFactorCode) {
			return;
		}

		setLoadingTwoFactor(true);

		try {
			await dispatch(loginTwoFactor(
				selectedUserContext.userName,
				loginModel.password,
				selectedUserContext.domain,
				loginModel.rememberme,
				loginMode,
				localStorage.getItem("i18nextLng"),
				loginModel.twoFactorCode
			));

			redirectAfterSuccessfulLogin();
		} catch (error) {
			showMessage(setMessageConfig, true, __MessageTypes.ERROR, t((error && error.response && error.response.data && error.response.data.message) || 'data-lang-msg-internalerror'));
		} finally {
			setLoadingTwoFactor(false);
		}
	};

	const handleBack = (e) => {
		resetEmailCaptcha();
		resetLoginCaptcha();
		resetAADCaptcha();
		stopTwoFactorTimer();

		setLoginModel(prevState => ({
				...prevState,
				email: "",

				domain: "",
				password: "",
		  
				rememberme: false,
		  
				emailValidated: false,
				formTwoFactorEnabled: false,
				clientUserListAccess: null,
		  
				twoFactorCode: "",
		}));
		setLoginMode(null)

		setDomainList(null);

		setIsInValidLoginModel(prevState => ({
			...prevState,
			email: false,
			domain: false,
			password: false,
			emailMessageError: "",
			passwordMessageError: "",
	
			twoFactorCode: false,
			twoFactorCodeMessageError: "",
		}));

		setMessageConfig({
			message: null,
			messageType: "",
			showMessage: false,
		});
	};

	const handleShowHidePassword = (e) => {
		setShowPassword(!showPassword);
	};

	const onChangeEmail = (e) => {
		clearMessage();

	  const _email = e.target.value;
	  setIsInValidLoginModel(prevState => ({
		...prevState,
		email: (_email === ""),
		emailMessageError: (_email === "") ? t('data-lang-msg-required') : ""
	  }));

	  setLoginModel(prevState => ({
		...prevState,
		email: _email
	  }));
	};

	const handleKeyDown = (e) => {
	  if (e.key === 'Enter') {
		e.preventDefault();
		e.stopPropagation();

		if (loginMode === "FBA") {
		  if (!loginModel.emailValidated) {
			handleValidateEmail();
		  }
		  else if (loginModel.formTwoFactorEnabled) {
			handleTwoFactorLogin();
		  }
		  else {
			handleLogin();
		  }
		}
	  }
	};

	const handleCheckAccount = (username) => {
		clearMessage();

	  const accounts = (loginModel.clientUserListAccess || []).map(account => ({
		  ...account,
		  selected: account.userName === username
	  }));

	  setIsInValidLoginModel(prevState => ({
		...prevState,
		username: false
	  }));

	  setLoginModel(prevState => ({
		...prevState,
		emailValidated: true,
		clientUserListAccess: accounts
	  }));
	};

	const handleValidateEmail = async (e) => {
		if (e !== undefined) {
			e.preventDefault();
		}

		validateEmailRecaptchaAndExecute()
	};

	const validateEmailRecaptchaAndExecute = async () => {
		if (loadingEmail) {
			return;
		}

		clearMessage();

		const token = (captchaRef.current && captchaRef.current.getValue ? captchaRef.current.getValue() : null);
		const _isInvalidEmail = isInValidEmail(loginModel.email);

		if (_isInvalidEmail) {
			setIsInValidLoginModel(prevState => ({
				...prevState,
				email: _isInvalidEmail
			}));
			return;
		}

		if (isNullUndefinedOrEmpty(token)) {
			showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-select-recaptcha'));
			return;
		}

		await manageGetClientsAccountsFromEmail(loginModel.email, "FBA", token);
	}

	const manageGetClientsAccountsFromEmail = async (email, accountType, recaptcha_token, msalToken = null) => {
		setLoadingEmail(true);

		try {
			const validateEmailFunction = accountType === "FBA" ? AuthService.validateEmailLogin : AuthService.validateEmailLoginAAD;

			const response = await validateEmailFunction(email, accountType, recaptcha_token, msalToken);

			if (!isNullUndefinedOrEmpty(response.data.l_users) && response.data.l_users.length > 0 && !isNullUndefinedOrEmpty(response.data.l_domain)) {
				const users = response.data.l_users.map((user, index) => ({
					...user,
					selected: response.data.l_users.length === 1 ? true : user.selected === true
				}));

				setLoginModel(prevState => ({
					...prevState,
					emailValidated: true,
					clientUserListAccess: users
				}));

				setDomainList(response.data.l_domain.map(item => ({ key: item, name: item })));
				return;
			}

			setLoginModel(prevState => ({
				...prevState,
				emailValidated: false,
				clientUserListAccess: []
			}));

			showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-invalidlogin'));
			if (accountType === "FBA") {
				resetEmailCaptcha();
			}
		} catch (error) {
			showMessage(setMessageConfig, true, __MessageTypes.ERROR, t((error && error.response && error.response.data && error.response.data.message) || 'data-lang-msg-internalerror'));
			if (accountType === "FBA") {
				resetEmailCaptcha();
			}
		} finally {
			setLoadingEmail(false);
		}
	};

	const loginWithAAD = async (type) => {
		if (loadingAAD) {
			return;
		}

		clearMessage();

		setLoadingAAD(true);

		try {
			await instance.loginRedirect(loginRequest);
		} catch (error) {
			setLoadingAAD(false);
			showMessage(setMessageConfig, true, __MessageTypes.ERROR, t((error && error.message) || 'data-lang-msg-internalerror'));
		}
	};

	const loginWithFBA = (type) => {
		clearMessage();
	  setLoginMode(type)
	};

	const handleForgotPassword = () => {
		clearMessage();

		if (isNullUndefinedOrEmpty(getSelectedAccount())) {
			showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-selectaccount')) 
		}
		else {
			history.push('/forgotpassword', { _loginModel: loginModel })
		}
	}

	let queryTk = new URLSearchParams(window.location.search).get('tk');

	return (
		<>
			{
				queryTk !== null && queryTk !== undefined ?
				<SetAuth/> :
				<>
					<BackgroundSlider
					images={[img1, img2, img3]}
					duration={10} transition={2} />

					<Container style={{ marginTop: "300px"}} className="col-xl-5 login-bg">
						<Card className="card-container">
						<div style={{margin: -30}} className="align-self-end">
						<LanguajeFlags />
						</div>
						<div className="profile-img-card">
							<Image
							src={sg3}
							alt="profile-img"
							/>
						</div>

						<Form ref={form} onKeyDown={handleKeyDown}>
							<fieldset >
								{
									loginMode === "FBA" &&
									<>
										<Form.Group className="mb-3">
										{
											!loginModel.emailValidated && !loginModel.formTwoFactorEnabled &&
											<Row>
												<Col xl={12}>
													<Form.Group className="mb-3">
														<Form.Label htmlFor="email">{t('data-lang-lbl-email')}</Form.Label>
														<Form.Control
														id="txtEmail"
														name="email"
														type="text"
														className="form-control"
														value={loginModel.email}
														onChange={onChangeEmail}
														isInvalid={isInValidLoginModel.email !== null ? isInValidLoginModel.email : false}
														autoComplete="off"
														placeholder="" required={true} /> 
														{
															isInValidLoginModel.email === true &&
															<div className="invalid-feedback">
															{isInValidLoginModel.emailMessageError}
															</div>
														} 
													</Form.Group>
												</Col>
												<Col xl={12} className="recaptcha-segment">
													<ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} ref={captchaRef} />
												</Col>
											</Row>
										}
										{
											loginModel.emailValidated && !loginModel.formTwoFactorEnabled &&
											<>
												<Form.Group className="mb-3">
													<Row>
														{
															domainList && loginModel.clientUserListAccess && (loginModel.clientUserListAccess.find(x => x.selected) !== undefined ? loginModel.clientUserListAccess.find(x => x.selected).userName.startsWith('sAdmin\\') : false) &&
															<Col xl={4}>
																<Form.Group className="mb-3">
																<Form.Label htmlFor="autCompleteDomain">{t('data-lang-lbl-client')}</Form.Label>
																	<TagPicker
																		selectionAriaLabel={t('data-lang-lbl-selecteddomain')}
																		onResolveSuggestions={filterSuggestedDomains}
																		getTextFromItem={getTextFromItem}
																		pickerSuggestionsProps={{
																			suggestionsHeaderText: t('data-lang-msg-suggestions-autocomplete'),
																			noResultsFoundText: t('data-lang-msg-nosuggestions-autocomplete'),
																		}}
																		style={{minWidth: 50}}
																		onChange={handleChangeAutocomplete}
																		itemLimit={1}
																		pickerCalloutProps={{ doNotLayer: true }}
																		inputProps={{
																			className: (isInValidLoginModel.domain !== null ? (isInValidLoginModel.domain ? "form-control is-invalid" : "form-control")  : "form-control"),
																			isInvalid: (isInValidLoginModel.domain !== null ? isInValidLoginModel.domain : false)
																		}}
																		styles={{input: {border: "none !important"}, text: {border: "1px solid #ced4da !important"}}}
																	/>
																{
																	isInValidLoginModel.domain === true &&
																	<div style={{display:"block"}} className="invalid-feedback">
																	{t('data-lang-msg-required')}
																	</div>
																}
																</Form.Group>
															</Col>
														}   
														<Col xl={loginModel.clientUserListAccess && (loginModel.clientUserListAccess.find(x => x.selected) !== undefined ? loginModel.clientUserListAccess.find(x => x.selected).userName.startsWith('sAdmin\\') : false) ? 8 : 12}>
															<Form.Label htmlFor="username">{t('data-lang-lbl-username')}</Form.Label>
															<Form.Group className="mb-3 overflow-y-auto" style={{maxHeight: '120px'}}>
																{
																	loginModel.clientUserListAccess && loginModel.clientUserListAccess.map((x, index) => 
																		<div key={index} className="border pointer" onClick={() => handleCheckAccount(x.userName)}>
																			<Card.Body className="p-1">
																				<Row>
																					<Col>{x.userName}</Col>
																					<Col className="col-auto me-auto">
																						<input type="radio" name="accountRadio" className="pointer" disabled={loginModel.clientUserListAccess.length === 1} checked={x.selected} onChange={() => handleCheckAccount(x.userName)}/>
																					</Col>
																				</Row>
																			</Card.Body>
																		</div>
																	)
																}
															</Form.Group>     
														</Col>
														{
															isInValidLoginModel.username &&
															<Col>
																<div className="invalid-feedback" style={{display: "block"}}>
																	{t('data-lang-msg-required-username')}
																</div>
															</Col>
														}
													</Row>
												</Form.Group>
												<Form.Group className="mb-12">
													<Form.Label htmlFor="password">{t('data-lang-lbl-password')}</Form.Label>
													<div className="input-group mb-3">
														<Form.Control
														id="txtPassword"
														name="password"
														type={showPassword ? "text" : "password"}
														className="form-control"
														value={loginModel.password}
														onChange={onChangePassword}
														isInvalid={isInValidLoginModel.password !== null ? isInValidLoginModel.password : false}
														placeholder="" required={true} /> 
														<span className="input-group-text" onClick={() => handleShowHidePassword("pass")}>
															{!showPassword && <AiOutlineEyeInvisible />}
															{showPassword && <AiOutlineEye />}
														</span>
														{
															isInValidLoginModel.password === true &&
															<div className="invalid-feedback">
																{t('data-lang-msg-required-password')}
															</div>
														}  
													</div>
												</Form.Group>
												<Form.Group className="mb-12">
													<Row>
														<Col xl={12} className="recaptcha-segment">
															<ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} ref={captchaLoginRef} />
														</Col>
													</Row>
												</Form.Group>
												<Form.Group className="mb-3 d-none">
													<Form.Check>
														<Row>
														<Col xl={1}>
															<Form.Check.Input
															id="rememberme"
															type="checkbox"
															checked={loginModel.rememberme}
															className="mt-2"
															onChange={onChangeRememberMe} />
														</Col>
														<Col xl={11}>
															<Form.Check.Label htmlFor="rememberme">{t('data-lang-lbl-rememberme')}</Form.Check.Label>
														</Col>
														</Row>
													</Form.Check>
												</Form.Group>
											</>
										}
										{
											loginModel.emailValidated && loginModel.formTwoFactorEnabled &&
											<Row>
												<Col xl={12}>
													<Form.Group className="mb-3">
														<Form.Label htmlFor="twoFactorCode">{t('data-lang-lbl-twofactorcode')}</Form.Label>
														<Form.Control
														id="txtTwoFactorCode"
														name="twoFactorCode"
														type="text"
														className="form-control"
														value={loginModel.twoFactorCode}
														onChange={onChangeTwoFactor}
														isInvalid={isInValidLoginModel.twoFactorCode !== null ? isInValidLoginModel.twoFactorCode : false}
														autoComplete="one-time-code"
														inputMode="numeric"
														pattern="[0-9]*"
														maxLength={6}
														disabled={isTwoFactorCodeExpired || loadingTwoFactor || loadingResend}
														placeholder="" required={true} /> 
														{
															isInValidLoginModel.twoFactorCode === true &&
															<div className="invalid-feedback">
															{isInValidLoginModel.twoFactorCodeMessageError}
															</div>
														}
														<div className={isTwoFactorCodeExpired ? "text-danger small mt-1" : "text-muted small mt-1"}>
															{
																isTwoFactorCodeExpired
																? getTwoFactorExpiredMessage()
																: `${getTwoFactorExpiresInLabel()}: ${formatRemainingTime(twoFactorRemainingSeconds)}`
															}
														</div>
													</Form.Group>
												</Col>
											</Row>
										}
										</Form.Group>
										<Form.Group className="mb-3 text-end">
											{
											!loginModel.emailValidated && !loginModel.formTwoFactorEnabled &&
											<PrimaryButton className="w-100 text-center m-1" onClick={ () => handleValidateEmail() } disabled={loadingEmail} >
												{ loadingEmail && (<span className="spinner-border spinner-border-sm"></span>) }
												<span> { t('data-lang-btn-prelogin') } </span>
											</PrimaryButton>
											}
											{
											loginModel.emailValidated && !loginModel.formTwoFactorEnabled &&
											<PrimaryButton className="w-100 text-center m-1" onClick={ () => handleLogin() } disabled={loadingLogin || loadingEmail} >
												{ loadingLogin && (<span className="spinner-border spinner-border-sm"></span>) }
												<span> { t('data-lang-btn-login') } </span>
											</PrimaryButton>
											}
											{
											loginModel.emailValidated && loginModel.formTwoFactorEnabled &&
											<>
												<PrimaryButton className="w-100 text-center m-1" onClick={ () => handleTwoFactorLogin() } disabled={loadingTwoFactor || loadingResend || isTwoFactorCodeExpired} >
													{ loadingTwoFactor && (<span className="spinner-border spinner-border-sm"></span>) }
													<span> { t('data-lang-btn-login') } </span>
												</PrimaryButton>
												<DefaultButton className="w-100 text-center m-1" onClick={ () => handleResendTwoFactorCode() } disabled={loadingResend || loadingTwoFactor} >
													{ loadingResend && (<span className="spinner-border spinner-border-sm"></span>) }
													<span> { t('data-lang-btn-resentcode') } </span>
												</DefaultButton>
											</>
											}
											<DefaultButton className="w-100 text-center m-1" onClick={ () => handleBack() } disabled={isLoading} >
											<span> {t('data-lang-btn-goback')} </span>
											</DefaultButton>
										</Form.Group>
										{
											!isNullUndefinedOrEmpty(loginModel.clientUserListAccess) && !isNullUndefinedOrEmpty(loginModel.clientUserListAccess.find(x => x.selected === true)) && loginModel.emailValidated && !loginModel.formTwoFactorEnabled &&
											<div className="float-right form-group">
												<Row>
												<Col sm={12}>
													<div style={{cursor:"pointer", color:"#0d6efd", textDecoration: "underline"}} onClick={handleForgotPassword}>{t('data-lang-lbl-forgotpassword')}</div>
												</Col>
												</Row>
											</div>
										}
									</>
								}
								{
									loginMode === "AAD" &&
									<>
										<Form.Group className="mb-3">
										{
											loginModel.emailValidated &&
											<>
												<Form.Group className="mb-3">
													<Row>
														{
															domainList && loginModel.clientUserListAccess && (loginModel.clientUserListAccess.find(x => x.selected) !== undefined ? loginModel.clientUserListAccess.find(x => x.selected).userName.startsWith('sAdmin\\') : false) &&
															<Col xl={4}>
																<Form.Group className="mb-3">
																<Form.Label htmlFor="autCompleteDomain">{t('data-lang-lbl-client')}</Form.Label>
																	<TagPicker
																	selectionAriaLabel={t('data-lang-lbl-selecteddomain')}
																	onResolveSuggestions={filterSuggestedDomains}
																	getTextFromItem={getTextFromItem}
																	pickerSuggestionsProps={{
																		suggestionsHeaderText: t('data-lang-msg-suggestions-autocomplete'),
																		noResultsFoundText: t('data-lang-msg-nosuggestions-autocomplete'),
																	}}
																	style={{minWidth: 50}}
																	onChange={handleChangeAutocomplete}
																	itemLimit={1}
																	pickerCalloutProps={{ doNotLayer: true }}
																	inputProps={{
																		className: (isInValidLoginModel.domain !== null ? (isInValidLoginModel.domain ? "form-control is-invalid" : "form-control")  : "form-control"),
																		isInvalid: (isInValidLoginModel.domain !== null ? isInValidLoginModel.domain : false)
																	}}
																	styles={{input: {border: "none !important"}, text: {border: "1px solid #ced4da !important"}}}
																	/>
																{
																	isInValidLoginModel.domain === true &&
																	<div style={{display:"block"}} className="invalid-feedback">
																	{t('data-lang-msg-required')}
																	</div>
																}
																</Form.Group>
															</Col>
														}   
														<Col xl={loginModel.clientUserListAccess && (loginModel.clientUserListAccess.find(x => x.selected) !== undefined ? loginModel.clientUserListAccess.find(x => x.selected).userName.startsWith('sAdmin\\') : false) ? 8 : 12}>
															<Form.Group className="mb-3">
																<Form.Label htmlFor="username">{t('data-lang-lbl-username')}</Form.Label>
																{
																	loginModel.clientUserListAccess && loginModel.clientUserListAccess.map((x, index) => 
																		<div key={index} className="border pointer" onClick={() => handleCheckAccount(x.userName)}>
																			<Card.Body className="p-1">
																				<Row>
																					<Col>{x.userName}</Col>
																					<Col className="col-auto me-auto">
																						<input type="radio" name="accountRadio" className="pointer" disabled={loginModel.clientUserListAccess.length === 1} checked={x.selected} onChange={() => handleCheckAccount(x.userName)}/>
																					</Col>
																				</Row>
																			</Card.Body>
																		</div>
																	)
																}                   
															</Form.Group>            
														</Col>
														{
															isInValidLoginModel.username &&
															<Col xl={12}>
																<div className="invalid-feedback" style={{display: "block"}}>
																	{t('data-lang-msg-required-username')}
																</div>
															</Col>
														}
													</Row>
												</Form.Group>
												<Form.Group className="mb-3 d-none">
													<Form.Check>
														<Row>
														<Col xl={1}>
															<Form.Check.Input
															id="rememberme"
															type="checkbox"
															checked={loginModel.rememberme}
															className="mt-2"
															onChange={onChangeRememberMe} />
														</Col>
														<Col xl={11}>
															<Form.Check.Label htmlFor="rememberme">{t('data-lang-lbl-rememberme')}</Form.Check.Label>
														</Col>
														</Row>
													</Form.Check>
												</Form.Group>
												<Form.Group className="mb-12">
													<Row>
														<Col xl={12} className="recaptcha-segment">
															<ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} ref={captchaAADRef} />
														</Col>
													</Row>
												</Form.Group>
											</>
										}
										</Form.Group>
										<Form.Group className="mb-3 text-end">
											{
												loginModel.emailValidated &&
												<PrimaryButton className="w-100 text-center m-1" onClick={ () => handleLogin() } disabled={loadingLogin || loadingEmail} >
													{ loadingLogin && (<span className="spinner-border spinner-border-sm"></span>) }
													<span> { t('data-lang-btn-login') } </span>
												</PrimaryButton>
											}
											<DefaultButton className="w-100 text-center m-1" onClick={ () => handleBack() } disabled={isLoading} >
											<span> {t('data-lang-btn-goback')} </span>
											</DefaultButton>
										</Form.Group>
									</>
								}
								{
									loginMode === null &&
									<>
										<Row>
											<Col>
												<DefaultButton iconProps={{ iconName: 'WebAppBuilderFragment' }} className="w-100 text-center m-1" onClick={ () => loginWithFBA("FBA") } disabled={isLoading} >{t('data-lang-lbl-loginwithsg3')}</DefaultButton>
											</Col>
										</Row>
										<Row>
											<Col className="d-flex">
											<div className="mt-1" style={{
												content: "",
												borderBottom: "1px solid #c2c8d0",
												flex: "1 0 auto",
												height: "0.5em",
												margin: "0",
											}}></div>
											<div>&nbsp;&nbsp;{t('data-lang-lbl-or')}&nbsp;&nbsp;</div>
											<div className="mt-1" style={{
												content: "",
												borderBottom: "1px solid #c2c8d0",
												flex: "1 0 auto",
												height: "0.5em",
												margin: "0",
											}}></div>
											</Col>
										</Row>
										<Row>
											<Col>
												<DefaultButton iconProps={{ iconName: 'WindowsLogo' }} className="w-100 text-center m-1" onClick={ () => loginWithAAD("AAD") } disabled={loadingAAD} >
													{ loadingAAD && (<span className="spinner-border spinner-border-sm"></span>) }
													<span> {t('data-lang-lbl-loginwithmicrosoft')} </span>
												</DefaultButton>
											</Col>
										</Row>
									</>
								}
								<div className="form-group">
									<MessageBox
										inputParam_Message={ messageConfig.message }
										inputParam_Display={ messageConfig.showMessage }
										inputParam_MessageType={ messageConfig.messageType }
										inputParam_SetterMessage={ setMessageConfig }
									/>
								</div>
							</fieldset>
						</Form>
						{
							integrationError === true &&
							<MessageBox
								inputParam_Message={ t('data-lang-msg-legacyintegrationerror') }
								inputParam_Display={ true }
								inputParam_MessageType={ __MessageTypes.WARNING }
								inputParam_SetterMessage={ null }
							/>
						}
						</Card>
					</Container>
				</>
			}
		</>
	);
};
	
export default Login;